<template>
  <div class="header-container">
    <div class="headerDiv">
      <img class src="../assets/logo.png" />
    </div>
    <Menu mode="horizontal" theme="bg" :active-name="name" class="nav">
      <MenuItem name="1">
        <router-link :to="{path:'/'}" class='menua'>首页</router-link>
      </MenuItem>
      <MenuItem name="2">
        <router-link :to="{path:'/train/index'}" class='menua'>线下课程</router-link>
      </MenuItem>
      <MenuItem name="3">
        <router-link :to="{path:'/online/index'}" class="menua">在线课程</router-link>
      </MenuItem>
      <MenuItem name="4">
        <router-link :to="{path:'/mall/index'}" class="menua">商城</router-link>
      </MenuItem>
      <!-- <MenuItem name="5"><router-link :to="{path:'/about/index'}" class='menua'>关于我们</router-link></MenuItem> -->
    </Menu>
  </div>
</template>

<script>
export default {
  props: ["name"],
  methods: {

  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/HeaderNav.vue